import React from "react";
import { useStore } from "../../store";

function openFullscreen(elem) {
  if (elem.requestFullscreen) {
    elem.requestFullscreen();
  } else if (elem.webkitRequestFullscreen) {
    /* Safari */
    elem.webkitRequestFullscreen();
  } else if (elem.msRequestFullscreen) {
    /* IE11 */
    elem.msRequestFullscreen();
  }
}

function closeFullscreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.webkitExitFullscreen) {
    /* Safari */
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) {
    /* IE11 */
    document.msExitFullscreen();
  }
}

export default function FullScreenToggle() {
  const { fullscreen, setFullscreen } = useStore();
  if (document.addEventListener) {
    document.addEventListener("webkitfullscreenchange", exitHandler, false);
    document.addEventListener("mozfullscreenchange", exitHandler, false);
    document.addEventListener("fullscreenchange", exitHandler, false);
    document.addEventListener("MSFullscreenChange", exitHandler, false);
  }

  function exitHandler() {
    if (
      !document.webkitIsFullScreen &&
      !document.mozFullScreen &&
      !document.msFullscreenElement
    ) {
      setFullscreen(false);
      window.dispatchEvent(new Event("resize"));
    }
  }

  const toggleFullScreen = React.useCallback(() => {
    if (!fullscreen) {
      openFullscreen(document.body);
    } else {
      closeFullscreen();
    }
    setFullscreen(!fullscreen);
  }, [fullscreen]);

  return <div className="full-screen-wrap" onClick={toggleFullScreen} />;
}
